var scope_0 = require('/home/ice/m/gats/new/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6f82b912fcec1736f23ff4aad5e9ad41.js').default;export default
        Object.assign({}, scope_0 )
    